import * as React from 'react';
import { cn } from '@/lib/utils';

const ChallengeCountdown = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'absolute inset-0 z-10 flex items-center justify-center bg-white/60 p-7 px-[max(16px,2.6vw)] text-center text-white',
      '[&_.c-avatar-wrapper]:absolute [&_.c-avatar-wrapper]:left-0 [&_.c-avatar-wrapper]:top-0 [&_.c-avatar-wrapper]:aspect-square [&_.c-avatar-wrapper]:h-[clamp(56px,7vw,90px)] [&_.c-avatar-wrapper]:w-[clamp(56px,7vw,90px)] [&_.c-avatar-wrapper]:-translate-x-[30%] [&_.c-avatar-wrapper]:-translate-y-[30%] [&_.c-avatar-wrapper]:border-[3px] [&_.c-avatar-wrapper]:border-solid [&_.c-avatar-wrapper]:border-primary-light [&_.c-avatar-wrapper]:shadow-[0px_4px_4px_0px_#00000040]',
      '[&_.c-button]:pointer-events-none [&_.c-button]:rounded-xl [&_.c-button]:bg-transparent [&_.c-button]:text-white',
      className
    )}
    {...props}
  />
));
ChallengeCountdown.displayName = 'ChallengeCountdown';

const ChallengeCountdownContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex min-h-[424px] w-[616px] max-w-full flex-col items-center justify-center gap-5 rounded-[32px] bg-primary p-4', className)}
    {...props}
  />
));
ChallengeCountdownContent.displayName = 'ChallengeCountdownContent';

const ChallengeCountdownHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('relative flex max-w-full flex-col gap-3', className)}
    {...props}
  />
));
ChallengeCountdownHeader.displayName = 'ChallengeCountdownHeader';

const ChallengeCountdownHat = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('mb-0 text-xs font-light leading-tight text-white', className)}
    {...props}
  />
));
ChallengeCountdownHat.displayName = 'ChallengeCountdownHat';

const ChallengeCountdownTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('mb-0 w-[336px] max-w-full rounded-2xl border-[3px] border-solid border-primary-light bg-white p-[clamp(12px,1.6vw,20px)] px-[clamp(24px,3.2vw,40px)] text-2xl font-extrabold uppercase leading-tight text-primary', className)}
    {...props}
  />
));
ChallengeCountdownTitle.displayName = 'ChallengeCountdownTitle';

const ChallengeCountdownBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('text-center', className)}
    {...props}
  />
));
ChallengeCountdownBody.displayName = 'ChallengeCountdownBody';

const ChallengeCountdownText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('mb-5 text-xl font-bold', className)}
    {...props}
  />
));
ChallengeCountdownText.displayName = 'ChallengeCountdownText';

export { ChallengeCountdown, ChallengeCountdownContent, ChallengeCountdownHeader, ChallengeCountdownHat, ChallengeCountdownTitle, ChallengeCountdownBody, ChallengeCountdownText };
